<account-manager-form [account-manager]="accountManagerModel"></account-manager-form>

